import markupCleaner from './markup-cleaner';
import siteLocales from './site-locales';

export default {
  markupCleaner,
  siteLocales,
};
